import { z } from 'zod'
import { clientObject } from '~/packages/general/client/clientObject'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const bullObject = z.object({
  id: z.string().uuid(),
  clientId: clientObject.shape.id,
  name: z.string(),
  breed: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type BullType = z.infer<typeof bullObject>

export const propertyMap = {
  id: sql`id`,
  clientId: sql`client_id`,
  name: sql`name`,
  breed: sql`breed`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
}
